import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { CSSTransition } from "react-transition-group"

import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"
import { RouterLink } from "~/components/RouterLink/RouterLink"

import { Logo } from "../Logo/Logo"
import { MenuLink } from "../MenuLink/MenuLink"
import { Burger } from "./components/Burger/Burger"
import styles from "./index.module.css"

const SubItems = ({ submenu }) => {
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  return (
    <div className={styles.SubItems}>
      {submenu.map(({ title, href, isEn }) => {
        if (currLang !== "ru" && !isEn) {
          return null
        }
        return (
          <MenuLink key={title[currLang]} className={styles.SubItem} href={href}>
            <span>{title[currLang]}</span>
          </MenuLink>
        )
      })}
    </div>
  )
}

// TODO убрать когда в апи будет приходить все меню
const SubItemsPortfolio = ({ submenu }) => {
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  return (
    <div className={styles.SubItems}>
      {submenu.map(({ slug, title }) => (
        <MenuLink key={title} className={styles.SubItem} href={`/service/${slug}`}>
          <span>{title}</span>
        </MenuLink>
      ))}
      <MenuLink className={styles.SubItem} href={"/cases"}>
        <span>{currLang === "ru" ? "Все проекты" : "All"}</span>
      </MenuLink>
    </div>
  )
}

const MenuItem = ({ onClick, title, as, href, active, isEn }) => {
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language
  if (currLang !== "ru" && !isEn) {
    return null
  }

  const Component = as || "a"

  return (
    <div className={styles.MenuItem}>
      <Component
        className={styles.Link}
        dangerouslySetInnerHTML={{ __html: title[currLang] }}
        data-state={active ? "active" : undefined}
        href={href && href[currLang] ? href[currLang] : href}
        onClick={onClick}
      />
    </div>
  )
}

export const MenuItems = ({ menuItems, menu }) => {
  const [activeMenuName, setActiveName] = useState("about")

  const openSubmenu = (name) => {
    const { name: activeMenuName } = menuItems.find((item) => item.name === name)
    setActiveName(activeMenuName)
  }

  const activeMenuItems = menuItems.find(({ name }) => name === activeMenuName)

  return (
    <div className={styles.Menu}>
      <div className={styles.MenuItemsWrapper}>
        <div className={styles.MenuItems}>
          {menuItems.map(({ title, href, submenu, name, isEn }, i) => {
            if (submenu) {
              return (
                <MenuItem
                  key={i}
                  active={name === activeMenuName}
                  isEn={isEn}
                  title={title}
                  onClick={() => openSubmenu(name)}
                />
              )
            }

            return <MenuItem key={i} as={RouterLink} href={href} isEn={isEn} title={title} />
          })}
        </div>

        {activeMenuName === "portfolio" ? (
          <SubItemsPortfolio submenu={menu.featurePages} />
        ) : (
          <SubItems submenu={activeMenuItems.submenu} />
        )}
      </div>
    </div>
  )
}

export const MobileMenu = ({ menuItems, onMenuToogle, style, menu }) => {
  const [menuIsOpen, openDropdown] = useState(false)

  const toggleMenu = () => {
    document.body.dataset.state = menuIsOpen ? "" : "no-scroll"
    document.documentElement.dataset.state = menuIsOpen ? "" : "no-scroll"
    openDropdown(!menuIsOpen)
    onMenuToogle(!menuIsOpen)
  }

  const closeMenu = () => {
    document.body.dataset.state = ""
    document.documentElement.dataset.state = ""
    openDropdown(false)
    onMenuToogle(false)
  }

  return (
    <React.Fragment>
      <div className={styles.Wrapper} style={style}>
        <div className="bb-container">
          <div className={styles.Navigation}>
            <Logo />
            <Burger menuIsOpen={menuIsOpen} onClick={toggleMenu} />
          </div>
        </div>
      </div>
      <CSSTransition
        classNames={{
          enter: styles.InnerEnter,
          enterActive: styles.InnerEnterActive,
          exitActive: styles.InnerExitActive,
        }}
        in={menuIsOpen}
        timeout={500}
        unmountOnExit
      >
        <div className={styles.Inner}>
          <MenuItems menu={menu} menuItems={menuItems} />
          <div className={styles.Overlay} onClick={closeMenu} />
        </div>
      </CSSTransition>
    </React.Fragment>
  )
}
